export const createOptions = (options) => {
  const optionsSelect = []
  options.map((option) => {
    const value = option?.id
    const label = option?.Description || option?.Language || option?.Nation || option?.Option
    optionsSelect.push({
      value: value,
      label: label
    })
  })
  return optionsSelect;
}